import React from "react";
import YouTube from "react-youtube";
import { Row, Col } from "react-bootstrap";

function YouTubeVideoList() {
  const videoIdsUpcoming = [
    "f9PpVhwZHOk",
    "oV_6Vm6Y794",
    "DnTJzBsgIfU",
    "a6ExNjFOhv0",
    "p3rOLWgkXPo",
    "TMsFsfrPNaw",
  ];

  const videoIdsTopRunning = [
    "Frp0zC4643U",
    "GJefvs947qE",
    "BKOVzHcjEIo",
    "8U4uGBoHa8c",
    "wT4HcYAeV5U",
    "jsauQx_Fwrg",
  ];

  const opts = {
    width: "100%",
    height: "200",
    playerVars: {
      autoplay: 0,
      rel: 0,
      modestbranding: 1,
    },
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* Upcoming Films */}
      <h4>Upcoming Films</h4>
      <Row className="g-3">
        {videoIdsUpcoming.map((videoId) => (
          <Col xs={12} sm={6} md={4} key={videoId}>
            <YouTube videoId={videoId} opts={opts} />
          </Col>
        ))}
      </Row>

      {/* Top Running Films */}
      <h4 className="mt-4">Top Running Films</h4>
      <Row className="g-3">
        {videoIdsTopRunning.map((videoId) => (
          <Col xs={12} sm={6} md={4} key={videoId}>
            <YouTube videoId={videoId} opts={opts} />
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default YouTubeVideoList;
